<template>
  <div id="calculation">
    <div class="form" :class="[$mq, {TA:isTestAchat}]">
      <h1>{{ $t("step3.title") }}</h1>
      <div class="section" :class="$mq">
        <div class="title">{{ $t("step3.position.title") }}</div>
        <ValidationObserver ref="observer" v-slot="{ valid }" slim>
          <div
            class="inline top city center"
            :class="$mq !== 'mobile' ? 'h-item-margin' : ''"
          >
            <label for="zipCode">
              <h4>{{ $t("step3.position.zip-code") }}</h4>
              <ValidationProvider
                name="zipCode"
                ref="zipCode"
                rules="required|numeric|min:4|max:4"
                v-slot="{ errors }"
                :customMessages="{ required: $t('step3.position.required') }">
                <div :class="{error: errors.length}">
                  <InputField type="text" id="zipCode" name="zipCode" v-model="zipCode" @input="getData()" />
                  <span v-if="errorMessageZipCode" class="input-error">{{errorMessageZipCode}}</span>
                  <span v-else class="input-error">{{ errors[0] }}</span>
                  <span v-if="isBxl && !allowBXResi" class="input-error">{{$t('validation.errors.no_supplied')}}</span>
                </div>
              </ValidationProvider>
            </label>

            <label for="city" class="grow">
              <h4>{{ $t("step3.position.city") }}</h4>
              <ValidationProvider
                name="city"
                ref="city"
                rules="required"
                v-slot="{ errors }">
                <SelectField
                  v-if="!isLoadingCity || !zipCode"
                  id="city"
                  name="city"
                  v-model="city"
                  :disabled="isLoadingCity"
                  :options="cityList"/>
                <div
                  class="input" :class="{TA:isTestAchat}"
                  v-if="zipCode && isLoadingCity">
                  <SvgIcon icon="loading"
                    class="loading-city"
                  />{{ $t("step3.loading") }}
                </div>
              </ValidationProvider>
            </label>
          </div>
        </ValidationObserver>
      </div>

      <div
        v-if="errorMessage"
        class="modal-container"
        :class="$mq"
        @click="close()"
      >
        <div class="modal" :class="$mq">
          <div class="close" @click="close()">x</div>
          {{ $t("step3.error-consumption") }}
        </div>
      </div>

      <div v-if="error" class="modal-container" :class="$mq" @click="close()">
        <div class="modal" :class="$mq">
          <div class="close" @click="close()">x</div>
          {{ $t("step3.error") }}
          <a @click="getData()">{{ $t("step3.error-choice1") }}</a
          >{{ $t("step3.error-choice2") }}
        </div>
      </div>
    </div>
    <div class="buttons inline space-between" :class="$mq">
      <PreviousButton @click="previousStep()" />
      <NextButton @click="nextStep()" />
    </div>
  </div>
</template>

<script>
import Providers from "./calculation/Providers";
import { mapGetters, mapState } from "vuex";
import InputField from "../components/Form/InputField.vue";
import NextButton from "../components/NextButton.vue";
import PreviousButton from "../components/PreviousButton.vue";
import SelectField from "../components/Form/SelectField.vue";
export default {
  data() {
    return {
      loadingCity: false,
      error: false,
      errorMessage: false,
      errorMessageZipCode: ""
    };
  },
  computed: {
    ...mapState("calculation", ["cityList", "providersElec", "area"]),
    ...mapGetters("energy", ["hasElec"]),
    ...mapGetters("calculation", ["isBxl"]),
    ...mapGetters("common", ["allowBXResi", "isTestAchat"]),
    isLoadingCity: {
      get() {
        return this.cityList.length > 0 ? this.loadingCity : true;
      },
    },
    zipCode: {
      get() {
        return this.$store.state.calculation.zipCode;
      },
      set(value) {
        if(!value || value.length > 4) {
          this.$store.commit("calculation/setCity", null);
          this.$store.commit("calculation/setCityList", []);
        }
        this.$store.commit("calculation/setZipCode", value);
      },
    },
    city: {
      get() {
        return this.$store.state.calculation.city;
      },
      set(value) {
        this.$store.commit("calculation/setCity", value);
      },
    },
    noSubscribe() {
      return this.$router.currentRoute.query.noSubscribe !== undefined || this.$store.state.common.noSubscribe;
    },
  },
  methods: {
    close() {
      this.error = false;
      this.errorMessage = false;
      this.errorZip = false;
    },
    previousStep: function() {
      this.$router.push({ name: "Energy", query: this.$route.query });
    },
    nextStep: async function () {
      await this.getProviders();
      const isValid = await this.$refs.observer.validate();
      if(!isValid || this.loadingCity === true || this.errorMessageZipCode) {
        return;
      }

      if (isValid && !this.errorMessage) {
        if (this.isBxl && !this.allowBXResi) {
          this.$store.commit('contact/setIsPro', true)
        }
        this.$store.commit("calculation/setValid", true);
        this.$store.dispatch("calculation/save");

        this.$router.push({ name: "Consumption", query: this.$route.query });
      }
    },
    getData() {
      if(this.zipCode.length >= 4) {
        this.getProviders();
      }
    },
    async getProviders() {
      try {
        this.loadingCity = true;
        await this.$store.dispatch("calculation/getProviders");
        this.loadingCity = false;
        this.errorMessageZipCode = "";
      } catch (error) {
        if(error.status === 400 && (error.data.error === "INVALID CP FORMAT" || error.data.error === "Bad zip code") && !this.$refs.zipCode.errors.length) {
          this.errorMessageZipCode = this.$i18n.t('step3.error-zip');
          this.$store.commit("calculation/setCityList", []);
          this.$store.commit("calculation/setCity", null);
        } else {
          if (!this.$refs.zipCode.errors.length) {
            console.error(error);
            this.error = true;
          }
        }
        this.loadingCity = false;
      }
    },
  },
  created() {
    if (this.zipCode) this.getData();
    window.scrollTo(0, 0);
  },
  components: {
    Providers,
    NextButton,
    PreviousButton,
    InputField,
    SelectField
  },
};
</script>

<style lang="scss" scoped>
.input-error {
  font-size: 0.8rem;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #f58b1e;
  display: block;
  line-break: auto;
  max-width: 250px;
}

.city {
  margin: auto 10%;
  .grow {
    min-width: 250px;
    max-width: 400px;
    .input {
      width: 100%;
    }

    div.input {
      display: flex;
      align-items: center;
      background: #f5f5f5;

      .loading-city {
        margin-right: 10px;
      }
    }
  }
}

.check-frame {
  font-weight: bold;
}

select:disabled {
  background: #f5f5f5;
}

.modal-container {
  position: fixed;
  overflow: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 20;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &.mobile {
    padding-top: 170px;
    position: fixed;
  }

  .modal {
    box-shadow: 0 0 7px rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 40%;
    padding: 20px 10px;
    border-top: 15px solid #fdcb47;
    border-radius: 30px;
    margin: 0 30%;
    margin-bottom: 20px;
    background: white;

    a {
      cursor: pointer;
      color: #fdcb47;
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }

    &.mobile {
      position: absolute;
      border-radius: 0;
      top: 0;
      margin: 0;

      .close {
        top: 0;
        right: 20px;
      }
    }

    .close {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      box-shadow: 0 0 7px rgba(0, 0, 0, 0.5);
      position: absolute;
      top: -20px;
      right: 0;
      background: black;
      border: 2px solid #fdcb47;
      color: #fdcb47;
      height: 25px;
      width: 25px;
      border-radius: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Calculation.vue